import { useEffect, useRef } from "react";
import { supabase } from "@/integrations/supabase/client";

export default function VercelDomainSync() {
  const synced = useRef(false);

  useEffect(() => {
    if (synced.current) return;
    synced.current = true;

    (async () => {
      try {
        const { data: { session } } = await supabase.auth.getSession();
        if (!session?.access_token) return;
        const { data: wsData } = await supabase
          .from("workspaces")
          .select("subdomain")
          .limit(1)
          .single();

        const sub = wsData?.subdomain;
        if (!sub) return;

        const { data: checkData } = await supabase.functions.invoke("vercel-domain", {
          body: { subdomain: sub, action: "check" },
        });

        if (checkData && !checkData.configured) {
          await supabase.functions.invoke("vercel-domain", {
            body: { subdomain: sub, action: "add" },
          });
        }
      } catch {
        // Silent fail - will retry on next login
      }
    })();
  }, []);

  return null;
}
